import React from "react";
import striptags from "striptags";

/**
 * @typedef {import('../../types.js').Component} Component
 */

/**
 * Provides a html sanitizer fot the dangerouslySetInnerHTML method
 * @param  { string } value - The value to sanitize
 * @returns { { __html: string } } html
 */
function createMarkup(value) {
  // We are only allowing p tags right now.
  // See https://www.npmjs.com/package/sanitize-html for options.
  const allowedTags = ["p"];
  return { __html: striptags(value, allowedTags) };
}

/**
 * @typedef {object} TextProps
 * @property {Component} value - The value to render
 */
/**
 * @type {React.FC<TextProps>} Renders a HTML paragraph element
 * @returns {React.ReactElement} React function component
 */
function HelperText({ component }) {
  const { value } = component;

  return (
    <div
      // @see https://react.dev/reference/react-dom/components/common#dangerously-setting-the-inner-html
      className="fr-text-lg fr-font-regular fr-mb-4"
      dangerouslySetInnerHTML={createMarkup(value)}
    />
  );
}

export default HelperText;
